
import IconButton from '@mui/joy/IconButton';
import Tooltip from '@mui/joy/Tooltip';

import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import SaveRoundedIcon from '@mui/icons-material/SaveRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import { Link, useNavigate } from 'react-router-dom';
import { ButtonGroup } from '@mui/joy';
import { useFormContext, useFormState } from 'react-hook-form';
import WarningDialog from './dialogs/WarningDialog';

export default function SaveButtons() {
    const navigate = useNavigate();
    // todo: use form context and determine if dirty
    const { control, formState } = useFormContext();
    const { dirtyFields } = useFormState({
        control
    });

    //isValid

    // console.log(dirtyFields);

    const confirmCancel = () => {
        navigate('../');
    }

    const shouldDisplayCancelWarning = !!Object.keys(dirtyFields).length;

    const cancelEditing = () => {
        if(Object.keys(dirtyFields).length) {
            // confirmation modal
            console.log('DISPLAY CONFIRMATION BEFORE CANCELLING');
        }
        navigate('../');
    }

    /*
    const navigate = useNavigate();

    const onClick = () => {
        //props.onClick
        navigate("create", { relative: "path" });
    }
    */

    return (
        <ButtonGroup
            size="sm"
            color="neutral"
            variant="outlined"
        >
                {/* <Link to="../" relative='path'> */}
                <WarningDialog
                    onConfirm={confirmCancel}
                    shouldDisplay={shouldDisplayCancelWarning}
                    activateButton={(props)=>
                        <Tooltip title='Cancel Editing'>
                            <IconButton
                                // component={Link}
                                // to="../" relative='path'
                            /*
                                size="sm"
                                color="neutral"
                                variant="outlined"
                                */
                                sx={{ bgcolor: 'background.surface' }}
                                // onClick={cancelEditing}
                                {...props}
                                >
                                <CloseRoundedIcon />
                            </IconButton>
                    </Tooltip>
                    }
                />
                {/* </Link> */}
            <Tooltip title='Save Edits'>
                <IconButton
                    component="button"
                    type="submit"
                    disabled={!formState.isValid}
                    /*
                    size="sm"
                    color="neutral"
                    variant="outlined"
                    */
                    sx={{ bgcolor: 'background.surface' }}
                    >
                    <SaveRoundedIcon />
                </IconButton>
            </Tooltip>
        </ButtonGroup>
    );
}
